"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var title = props.title,
      className = props.className,
      styles = props.styles,
      restProps = __rest(props, ["title", "className", "styles"]);

  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: 'svg-scale',
    ref: ref
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'svg-filter'
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "60px",
    height: "60px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 114",
    className: "design-iconfont"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.0878099,30.0390178 L82.4381908,54.7230515 C82.8122427,54.9312371 82.9436418,55.3978303 82.7316792,55.7652167 C82.6622131,55.8856194 82.560778,55.9852469 82.4381908,56.0534751 L38.0878099,80.7375088 C37.7137579,80.9456943 37.2386992,80.8166367 37.0267364,80.4492504 C36.960414,80.3342966 36.9255533,80.2044243 36.9255533,80.072297 L36.9255533,30.7042296 C36.9255533,30.2819572 37.2740835,29.9396378 37.7040173,29.9396378 C37.8385418,29.9396378 37.9707706,29.9738775 38.0878099,30.0390178 Z",
    fill: "#FFF",
    transform: "translate(2.303823 2.61167)"
  })))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;